import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { DeleteWarehouseGroup, LogisticsActionKeys } from '..';
import { lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteWarehouseGroup } from '../logisticsApi';

function* deleteWarehouseGroupSaga(action: DeleteWarehouseGroup) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(deleteWarehouseGroup, action.payload.warehouseGroupId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(lookupActionCreators.removeLookupValue({ type: 'warehouseGroups', id: action.payload.warehouseGroupId }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteWarehouseGroup() {
  yield takeEvery(LogisticsActionKeys.DELETE_WAREHOUSE_GROUP, deleteWarehouseGroupSaga);
}
